import {
  PayloadAction,
  createSlice,
  SliceCaseReducers,
  ValidateSliceCaseReducers,
  ThunkDispatch,
  AnyAction,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit';
import { initialState, RealtimeState } from 'shared/store/realtime-slice';
import { Trigger } from 'types';

export type RealtimeKitReducer = (
  state: RealtimeState,
  action: PayloadAction<any>,
) => void;
export type RealtimeKitReducers = Record<string, RealtimeKitReducer>;
type RealtimeKitVisitorUpdateReducer = (
  state: RealtimeState,
  userId: number | undefined,
) => void;

export type TriggerHandler = (
  trigger: Trigger,
  state: any,
  dispatch: ThunkDispatch<any, AnyAction, any>,
) => void;

export interface RealtimeKit<R = RealtimeKitReducers> {
  reducers: R;
  extraReducers?: (builder: ActionReducerMapBuilder<RealtimeState>) => void;
  triggerThunkHelper: TriggerHandler;
  visitorUpdateReducer: RealtimeKitVisitorUpdateReducer;
  useKitHook: () => void;
}

export const createRealtimeReducerActions = <
  Reducers extends SliceCaseReducers<RealtimeState>
>({
  reducers,
}: {
  reducers: ValidateSliceCaseReducers<RealtimeState, Reducers>;
}) => {
  const slice = createSlice({
    name: 'realtime',
    initialState,
    reducers,
  });

  return slice.actions;
};

export function createKit<T extends RealtimeKit>(config: T): T {
  return config;
}

export const getIntendedVisitor = (state: RealtimeState) =>
  (state.intendedVisitorId && state.visitorMap[state.intendedVisitorId]) || null;

export const getIntendedAssocVisitor = (state: RealtimeState) => {
  const intVis = getIntendedVisitor(state);
  if (intVis && state.sid && intVis.helpedBySid === state.sid) {
    return intVis;
  }
  return null;
};
